import React from "react"
import mount from "core/mount"
import { OldButton } from "@kit/design/old-button"
import Note from "@kit/design/note"

function UnconfirmedSendAddressBanner({ emailSettingsLink }) {
  return (
    <Note type="warning" size="sm" className="bg-system-yellow-100!">
      <p className="grow">
        <strong>
          One or more sending email addresses needs to be confirmed.
        </strong>{" "}
        Confirm an address to start using it for sending.
      </p>
      <OldButton
        is="plain"
        size="sm"
        href={emailSettingsLink}
        target="_blank"
        className="ml-4 shrink-0 bg-system-yellow-400 hover:bg-system-yellow-500"
      >
        Manage email addresses
      </OldButton>
    </Note>
  )
}

export { UnconfirmedSendAddressBanner }

mount({ "Account.UnconfirmedSendAddressBanner": UnconfirmedSendAddressBanner })
